/* eslint-disable arrow-body-style */
import { useState, useCallback } from 'react'
import { generateId } from '@components/Ackodrive/common/utils'
import Image from 'next/image'
import { Ul, CollapsibleHeader, TocContainer } from './styles'

const TableOfContents = ({ list }) => {
  const [isOpen, setIsOpen] = useState(false)
  const tableOfContentsId = 'table-of-contents-ackodrive'

  const toggleContent = useCallback(() => {
    setIsOpen(!isOpen)
  }, [isOpen])

  if (list.length > 0) {
    return (
      <TocContainer id={tableOfContentsId}>
        <CollapsibleHeader onClick={toggleContent}>
          <div>
            <span>Contents</span>
          </div>
          <Image
            src="/images/arrow-up-grey.svg"
            width="20"
            height="20"
            alt="ArrowUpGrey icon"
            layout="fixed"
            className={isOpen ? 'open' : 'close'}
          />
        </CollapsibleHeader>
        {isOpen ? (
          <Ul listStyleTypeNone hide={!isOpen}>
            {list.map((item: any) => {
              return (
                <li key={item?.id}>
                  <a href={`#${generateId(item?.text)}`}>{item?.text}</a>
                  <Ul>
                    {item?.children.map(child => {
                      return (
                        <li key={child.id}>
                          <a href={`#${generateId(child.text)}`}>{child.text}</a>
                        </li>
                      )
                    })}
                  </Ul>
                </li>
              )
            })}
          </Ul>
        ) : null}
      </TocContainer>
    )
  }
  return null
}

export default TableOfContents
